import { platform as webToNativePlatform } from 'webtonative';

export const APP_REVIEW_PROMPT_DELAY_MS = 2_000;
export const APP_REVIEW_COOLDOWN_MS = 90 * 24 * 60 * 60 * 1_000;
export const APP_REVIEW_TRIGGER_SOURCE = 'probability_global_leaderboard';

export type AppReviewPlatform = 'android' | 'ios';

export const getAppReviewPlatform = (): AppReviewPlatform | null => {
	if (webToNativePlatform === 'ANDROID_APP') return 'android';
	if (webToNativePlatform === 'IOS_APP') return 'ios';
	return null;
};

export const hasAppReviewCooldownElapsed = (
	appReviewPromptDate?: string | Date | null,
	now = Date.now()
): boolean => {
	if (!appReviewPromptDate) return true;

	const promptTimestamp = new Date(appReviewPromptDate).getTime();
	if (!Number.isFinite(promptTimestamp)) return true;

	return now - promptTimestamp >= APP_REVIEW_COOLDOWN_MS;
};
